export const SET_COINS_HISTORY = 'SET_COINS_HISTORY'
export const SET_COINS_HISTORY_LOADING = 'SET_COINS_HISTORY_LOADING'
export const SET_COINS_HISTORY_LOADED = 'SET_COINS_HISTORY_LOADED'
